import React, { useState } from "react";
import { ChevronDown } from "lucide-react";
import Heading from "../../../utils/Heading";

const faqData = [
  {
    question: "What types of blinds do you offer?",
    answer:
      "We offer a wide range of customized blinds, including Roller Blinds, Zebra Blinds, Vertical Blinds, Venetian Blinds, Roman Blinds, Motorized Blinds, Outdoor Blinds, and Industrial PVC Blinds.",
  },
  {
    question: "Can blinds be customized according to my window size?",
    answer:
      "Yes. All our blinds can be customized according to your window dimensions, interior requirements, fabric preference, and design style.",
  },
  {
    question: "Do you provide measurement and installation services?",
    answer:
      "Yes, our team provides professional site measurement, product consultation, and installation services to ensure a perfect fit and finish.",
  },
  {
    question: "Are motorized blinds available?",
    answer:
      "Yes. We offer motorized and smart blinds that can be operated through a remote control and, depending on the system, integrated with smart-home solutions.",
  },
  {
    question: "How long does it take to install the blinds?",
    answer:
      "The installation timeline depends on the product type, quantity, and customization requirements. After site measurement and order confirmation, our team will provide an estimated delivery and installation schedule.",
  },
  {
    question: "How do I clean and maintain my blinds?",
    answer:
      "Most blinds can be easily maintained with regular dusting using a soft cloth, duster, or vacuum cleaner. Specific cleaning instructions may vary depending on the fabric and material.",
  },
];

export default function FnQ() {
  const [openIndex, setOpenIndex] = useState(0);

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="w-full bg-[#F5F1EA] py-5 sm:py-7 lg:py-24">
      <div className="mx-auto w-full max-w-[1400px] px-4 sm:px-4 lg:px-6">

        {/* Heading */}
        <div className="!mb-5 text-center">

          <Heading text={"Frequently Asked Questions"} className="!pb-2 sm:!pb-0" />
           <hr className="heading-seperator mx-auto border-t-4 border-[#66944b] opacity-90 w-16 sm:w-20 md:w-24 h-0.5 !mb-3 lg:!mb-0 lg:mt-2 md:mt-2 md:!mb-4 transition-all duration-500 hover:w-32" />          

          <p className="text-[#661E33]/80 font-medium text-sm sm:text-base md:text-lg max-w-2xl mx-auto px-2 mt-2">
            Find answers to some of the most common questions about our blinds,
            customization, installation, and maintenance.
          </p>
        </div>

        {/* FAQ List */}
        <div className="space-y-4">
          {faqData.map((faq, index) => {
            const isOpen = openIndex === index;

            return (
              <div
                key={index}
                className={`overflow-hidden rounded-xl border transition-all duration-300 ${
                  isOpen
                    ? "border-[#C9B79F] bg-white shadow-md"
                    : "border-[#DED6CC] bg-white/70"
                }`}
              >
                {/* Question */}
                <button
                  type="button"
                  onClick={() => handleToggle(index)}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left sm:px-7"
                >
                  <div className="flex items-start gap-4">
                    <span
                      className={`mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-sm font-semibold transition-all duration-300 ${
                        isOpen
                          ? "bg-[#174D32] text-white"
                          : "bg-[#EFE9E1] text-[#174D32]"
                      }`}
                    >
                      {index + 1}
                    </span>

                    <span className="text-base font-semibold text-[#24201C] sm:text-lg">
                      {faq.question}
                    </span>
                  </div>

                  <ChevronDown
                    size={21}
                    className={`shrink-0 text-[#174D32] transition-transform duration-300 ${
                      isOpen ? "rotate-180" : "rotate-0"
                    }`}
                  />
                </button>

                {/* Answer */}
                <div
                  className={`grid transition-all duration-300 ease-in-out ${
                    isOpen
                      ? "grid-rows-[1fr] opacity-100"
                      : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <div className="border-t border-[#EEE8E0] px-5 pb-6 pt-4 pl-16 sm:px-7 sm:pl-[4.5rem]">
                      <p className="text-sm leading-7 text-gray-600 sm:text-base">
                        {faq.answer}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

      </div>
    </section>
  );
}